<template>
    <modal-cadu @input="$emit('close', false)" close :width="654" :value="show">
        <div slot="all" class="py-8 px-10">
            <div slot="header" class="fontColor--text title font-weight-regular">
                {{titulo}}
            </div>
            <div slot="body" class="linha">
                <v-row no-gutters>
                    <v-col cols="12" class="pt-2 pl-2">
                        <div class="font-secundaria fontColor--text subtitle-1">
                            {{texto}}
                        </div>
                    </v-col>
                    <v-col cols="12" align="center" class="pt-4">
                        <v-row align="center" class="px-5" v-if="!$vuetify.breakpoint.xs">
                            <v-col cols="auto" class="px-0">
                                <button-cadu
                                    text="CANCELAR"
                                    :backColor="$vuetify.theme.themes.light.fontColor"
                                    @click="$emit('close', false)"
                                    outline
                                />
                            </v-col>
                            <v-row justify="end" no-gutters>
                                <v-col cols="auto">
                                    <button-cadu
                                        text="NÃO"
                                        @click="notUpload"
                                    />
                                </v-col>
                                <v-col cols="auto">
                                    <button-cadu
                                        class="px-4"
                                        text="SIM, EFETUAR UPLOAD"
                                        @click="upload"
                                        block
                                    />
                                </v-col>
                            </v-row>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12">
                                <button-cadu
                                    text="SIM, EFETUAR UPLOAD"
                                    @click="upload"
                                    block
                                />
                            </v-col>
                            <v-col cols="12">
                                <button-cadu
                                    text="NÃO"
                                    @click="notUpload"
                                    block
                                />
                            </v-col>
                            <v-col cols="12">
                                <button-cadu
                                    text="CANCELAR"
                                    @click="$emit('close', false)"
                                    outline
                                    block
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
            <div slot="footer">

            </div>
        </div>
    </modal-cadu>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: false
    },
    titulo: {
      type: String,
      required: true
    },
    texto: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      show: this.value
    }
  },
  methods: {
    notUpload () {
      this.$emit('semAnexar')
    },
    upload () {
      this.$emit('anexarUpload')
    }
  },
  watch: {
    value () {
      this.show = this.value
    }
  }
}
</script>

<style lang="sass" scoped>
.linha
    border-top: 1px solid #DEE2E6
    width: 98%
    margin: 5px 0
</style>
